import type { Resource } from '../../';
export const product_sizeChart_descriptionTop: Resource = {"default":"Our site uses US sizing. The charts below compare US sizes to international sizes."};
